<template>
  <simple-activity :show-header="false" :show-close-button="false">
  <div class="image-background" style="overflow-x: hidden">
    <div class="app-container" style="display: flex; flex-direction: column; justify-content: center;">
      <div class="bg-primary" style="width: 100%;">
        <b-col>
          <h3 class="py-1 text-light text-center"><b>{{ $tr('invitation_received', 'Invitation Received') }}</b></h3>
        </b-col>
      </div>

      <!-- CONTENT -->
      <b-container>
        <b-row class="mt-3">
          <b-col>
            <h5 class="alert alert-info text-center">{{ $tr('invitation_company_received', 'You received invitation from company:') }} <strong>{{invitationInfo.companyName}}</strong></h5>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <h5>{{ $tr('invitation_accepting', 'After Accepting the Invitation - You Can:') }}</h5>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-center align-items-center">
          <b-col class="col-12 mt-3">
            <div class="alert alert-info text-center">{{ $tr('invitation_inquires', 'Exchange Offers and Inquiries') }}</div>
            <div class="alert alert-info text-center">{{$tr('invitation_technical', 'Exchange Technical Specifications')}}</div>
            <div class="alert alert-info text-center">{{ $tr('invitation_comments', 'Exchange Comments') }}</div>
            <div class="alert alert-info text-center">{{$tr('invitation_messages', 'Exchange Messages')}}</div>
            <div class="alert alert-info text-center">
              {{$tr('invitation_data', ' No data will be exchanged until you take a separate action to do that (like send inquiry or explicitly share the product specification')}}}
            </div>
          </b-col>
        </div>
        <b-row no-gutters class="px-3">
          <b-col class="col-12 border rounded">
            <h5 class="border-bottom p-1 m-2">{{$tr('invitation_note', 'Note:')}}</h5>
            <div v-if="invitationInfo.note" class="p-1 m-2">{{invitationInfo.note}}</div>
            <div v-else class="p-1 m-2">{{$tr('invitation_nothing', 'Nothing to Add Here.')}}</div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
      <!-- CONTENT END-->

    <!-- FOOTER -->
    <template v-slot:footer>
      <b-button
          data-test-path="close-button"
          variant="plm-tertiary"
          :class="'size-button mx-2'"
          @click.stop="close()"
      >
        <font-awesome-icon icon="trash" class="fa-xl"/>
        <span ref="label" class="d-none d-md-inline pl-1">
        {{ $tr('invitation_reject', 'Reject') }}
      </span>
      </b-button>

      <b-button
          data-test-path="accept-invite-button"
          variant="plm-primary"
          :class="'size-button  mx-2'"
          @click.stop="accept()"
      >
        <font-awesome-icon icon="check" class="fa-xl"/>
        <span ref="label" class="d-none d-md-inline pl-1">
        {{ $tr('invitation_accept', 'Accept') }}
      </span>
      </b-button>
    </template>
    <!-- FOOTER END -->
  </simple-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FormHeader from "@/components/forms/FormHeader";
import FooterButton from "@/components/navbar/FooterButton";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import CloseButton from "@/components/navbar/CloseButton";
import Log from "@/utils/Log";
import VBox from "@/components/VBox";
import SelectActivityRenderer from "@/components/forms/renderers/SelectActivityRenderer.vue";
import SelectActivityInput from "@/components/forms/renderers/SelectActivityInput.vue";
import Suppliers from "@/server/com/silkplm/model/plm/Suppliers";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity.vue";


export default {
  name: "InvitationActivity",
  components: {
    SimpleActivity,
    SelectActivityInput,
    SelectActivityRenderer, VBox, CloseButton, FooterNavbar, HeadersButtonGroup, FooterButton, FormHeader
  },
  permission: Perms.SUPERUSER,

  methods: {

    ...Activity.methods,

    getTitle() {
      return "Invitation";
    },
    async canClose() {
      return true;
    },

    async accept() {
      this.setResult("Accept");
      this.close();
    },

  },
  props: {
    invitationInfo: {default: {}}
  },
  data: function () {

    return {
      formClass: Suppliers.getRemoteClass(),
      contactSelected: false,
      contact: null,
      unsavedChanges: false,
      permissions: new PermissionsSet(),
      fieldConfig: null
    }
  }
}
</script>

<style scoped>
.image-background {
  margin: 0;
  padding: 0;
  height: 80vh;
  background-image: url("https://silkplm.com/wp-content/uploads/2024/05/Background-1.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}
</style>
